<template>
   <div class="formWrapper mt-5">
      <div class="formWrapper__header">
        <Icon icon="additional-info" class="formWrapper__header__icon" />
        <h3>Dodatkowe dane do umieszczenia na fakturze</h3>
        <tooltip text="(np. nr zamówienia PO)" class="formWrapper__header__info">
          <span class="mi mi-info"></span>
        </tooltip>
      </div>
      <div class="formWrapper__inner additionalInfo__comment">
        <p>
          Poniżej zapisz dodatkowe informacje, które chcesz, żeby były umieszczone na fakturze.
          <br />
          <b>Komentarz do realizacji zamówienia będzie można dodać w następnym kroku.</b>
        </p>
        <textarea
          name="additionalFvInfo"
          v-model="additionalFvInfo"
          id="additionalFvInfo"
          cols="30"
          rows="5"
          maxlength="150"
          placeholder="Np. numer zamówienia PO"
        />
      </div>
    </div>
</template>

<script>
import { mapFields } from 'vuex-map-fields';
import Icon from '../Icon.vue';

export default {
  name: 'InvoiceAdditionalInfo',
  components: {
    Icon,
  },
  computed: {
    ...mapFields('additionalInfo', [
      'additionalFvInfo',
    ]),
  },
};
</script>

<style>

</style>
